module.exports = __webpack_public_path__ + "img/p25621.55469406.jpg";